<template>
  <ResponsivePopoverView v-model:active="active" placement="bottom">
    <template v-slot:target>
      <ButtonView type="shaded" color="foreground" size="small" :active="active || editor.isActive('heading')" @click="active = true">
        <i class="fas fa-heading fa-fw" style="font-size: 1.2em"></i>
      </ButtonView>
    </template>
    <template v-slot:body>
      <ButtonView v-if="editor.isActive('heading')" type="shaded" color="foreground" @click="editor.chain().focus().toggleHeading({ level: editor.getAttributes('heading')?.level ?? 0 }).run(); active = false">
        <i class="fas fa-text"></i>
      </ButtonView>
      <ButtonView type="shaded" color="foreground" v-for="level in [1, 2, 3, 4, 5, 6]" :key="level" :active="editor.isActive('heading', { level: level })" @click="editor.chain().focus().toggleHeading({ level: level }).run(); active = false">
        H{{ level }}
      </ButtonView>
    </template>
  </ResponsivePopoverView>
</template>

<script setup>
import ResponsivePopoverView from "../../../general/ResponsivePopoverView.vue";
import ButtonView from "../../../general/ButtonView.vue";
import {ref} from "vue";

defineProps({
  editor: Object
});

const active = ref(false);

</script>